<script>
import VideoSDKSuccess from '@/plans/VIDEO_SDK/success.vue';

export default {
  name: "VideoSDKUC",
  extends: VideoSDKSuccess,
}
</script>
